type Props = (src?: string) => string;

const imageSrc: Props = (src) => {
  return src || "/assets/img/empty.svg";
};

export default imageSrc;
